import I18n from 'I18n';
import styled from 'styled-components';
import { createActionCardCounters, createActionMap } from 'automation-ui-action-features/records/recordsUtils';
import { getActionMetadataConfigFromAction } from 'automation-ui-action-features/actions/ActionMetadataConfigUtils';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledActionCardHeader = styled.span.withConfig({
  displayName: "ActionHistoryHeader__StyledActionCardHeader",
  componentId: "sc-1liw7nb-0"
})(({
  theme
}) => `
  font-weight: ${theme.typography['heading-400'].fontWeight};

  span {
    font-weight: ${theme.typography['heading-400'].fontWeight};
  }
`);
// TODO (see) - add hooks for flow, extensionDefinitions; remove getter function
const ActionHistoryHeader = ({
  actionId: overrideActionId,
  action: overrideAction,
  actionLink,
  flow,
  extensionDefinitions
}) => {
  let actionId = overrideActionId;
  if (overrideAction) {
    const actionIdFromOverrideAction = overrideAction.getActionId();
    if (actionIdFromOverrideAction && typeof actionIdFromOverrideAction !== 'number') {
      throw new Error('overrideAction must have a numeric actionId');
    }
    actionId = actionIdFromOverrideAction;
  }
  const flowActionsMap = createActionMap(flow);
  const action = overrideAction || actionId && flowActionsMap.get(actionId);
  if (!action) {
    return null;
  }
  const actionDefinition = getActionMetadataConfigFromAction(action, undefined, extensionDefinitions);
  if (!actionDefinition) {
    return null;
  }
  const actionCardCounters = createActionCardCounters(flowActionsMap, flow.firstActionId);
  let prefix = actionId && actionCardCounters[actionId];
  if (!prefix) {
    prefix = I18n.text('automation-ui-management.actionHistoryHeader.deletedAction');
  }
  return /*#__PURE__*/_jsx(StyledActionCardHeader, {
    children: actionDefinition.getActionLabel(prefix, actionLink, undefined, action)
  });
};
export const getActionHistoryHeader = (flow, extensionDefinitions) => ({
  actionId,
  action,
  actionLink
}) => {
  if (!flow) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      "data-test-id": "action-history-header-skeleton"
    });
  }
  return /*#__PURE__*/_jsx(ActionHistoryHeader, {
    flow: flow,
    extensionDefinitions: extensionDefinitions,
    actionId: actionId,
    action: action,
    actionLink: actionLink
  });
};
export default ActionHistoryHeader;